module.exports = __webpack_public_path__ + "img/CWarship64_ua.591b611d.webp";